var exports = {
  "jF": "River__JJveXw",
  "fh": "Cell__cNExxX",
  "mO": "Wrapper__edLOsH",
  "UC": "Content__IsCNh3",
  "VY": "Description__e4LbDy",
  "D5": "CtaNote__F7xM61",
};

module.exports = exports;
